import Observer from "./observer"

class ObservableLocalStorage {
  private observer = new Observer()

  clear(): void {
    return localStorage.clear()
  }
  key(index: number): string | null {
    return localStorage.key(index)
  }

  getItem(key: string): string | null {
    const value = localStorage.getItem(key)
    if (value == null) return null

    try {
      return JSON.parse(value)
    } catch (error) {
      console.error(error)
      return null
    }
  }
  removeItem(key: string): void {
    localStorage.removeItem(key)
    this.observer.emit()
  }
  setItem(key: string, value: unknown): void {
    localStorage.setItem(key, JSON.stringify(value))
    this.observer.emit()
  }

  /**
   * @returns unsubscribe method.
   */
  observe(listener: () => void): () => void {
    return this.observer.observe(listener)
  }
}

export default new ObservableLocalStorage
